import { filterXSS } from "xss";

const whiteList = {
  a: ["href", "title", "target", "class"],
  p: ["class"],
  span: ["class"],
  br: [],
  ul: ["class"],
  li: ["class"],
  ol: ["class"],
  h1: ["class"],
  h2: ["class"],
  h3: ["class"],
  em: ["class"],
  u: ["class"],
  s: ["class"],
  img: ["src", "alt", "class"],
  strong: ["class"],
};

const newlineTags = ["p", "br", "ul", "li", "ol", "h1", "h2", "h3"];

export const safeHTML = (html: string) => {
  return {
    __html: filterXSS(html, {
      whiteList,
    }),
  };
};

export const toUTF8 = (str: string): string => {
  return encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, (match, p1) => {
    return String.fromCharCode(parseInt(p1, 16));
  });
};

export const fromUTF8 = (str: string): string => {
  return decodeURIComponent(
    Array.from(str)
      .map((c) => {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );
};

export const stripHtmlTags = (str: string, newline = true) => {
  try {
    str = filterXSS(str, {
      whiteList,
    });
    if (newline) {
      const tags = newlineTags.join("|");
      const regex = new RegExp(`</(${tags})>`, "g");
      str = str.replace(regex, "\n").trim();
    }
    return str.replace(/<\/?[^>]+(>|$)/g, "");
  } catch (error) {}
  return "";
};
